import { gateBooleanToBoolean } from "../../sg-core";

export enum ECertStatus {
    Valid = 'valid',
    Expires = 'expires',
    NotValid = 'not_valid',
    ValidationFailed = 'validation_failed'
};


export interface ICert {
    id: number;
    name: string;
    refrenceName: string;
    isTimeLimited: boolean;
};

export interface ICertDTO {
    id: number;
    nimi: string;
    viitenimi: string;
    maara_aikainen?: string | "Y" | "N";
};


export const CertMapper = {
    apiToDomain: (api: ICertDTO): ICert => {
        return ({
            id: api.id,
            name: api.nimi,
            refrenceName: api.viitenimi,
            isTimeLimited: api.maara_aikainen ? gateBooleanToBoolean(api.maara_aikainen) : false,
        })
    }
}

